import { Workbox } from "workbox-window";
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import type Vue from "vue";

export async function initServiceWorker(app: Vue) {
  if ("serviceWorker" in navigator) {
    const swUrl = `${process.env.VUE_APP_BASE_URL}service-worker.js`;
    const trackSW = (eventName: string, payload: Record<string, unknown> = {}) => {
      if (!globalThis.window.$appInsights) return;
      globalThis.window.$appInsights.trackEvent({
        name: `sw_${eventName}`,
        properties: {
          appVersion: process.env.VUE_APP_PWA_VERSION || "unknown",
          swUrl,
          ...payload
        }
      });
    };

    const wb = new Workbox(swUrl);
    wb.addEventListener("installed", event => {
      trackSW("installed", { isUpdate: !!event?.isUpdate });
    });
    wb.addEventListener("waiting", () => {
      trackSW("waiting");
    });
    wb.addEventListener("controlling", () => {
      trackSW("controlling");
    });
    wb.addEventListener("activated", event => {
      trackSW("activated", { isUpdate: !!event?.isUpdate });
    });

    const registration = await wb.register();
    const vapidKey = process.env.VUE_APP_WEBPUSH_KEY || "";
    if (vapidKey) {
      const firebaseConfig = {
        apiKey: "AIzaSyDhygukYlEXwlFYmxb_GQPH7_nHVhCXtgE",
        authDomain: "minhaomint.firebaseapp.com",
        databaseURL: "https://minhaomint.firebaseio.com",
        projectId: "minhaomint",
        storageBucket: "minhaomint.appspot.com",
        messagingSenderId: "1097192347158",
        appId: "1:1097192347158:web:7634dd3f682a50fc798737",
        measurementId: "G-MRWT2BKC0B"
      };

      const firebase = initializeApp(firebaseConfig);
      const messaging = getMessaging(firebase);

      onMessage(messaging, event => {
        const payload = event?.data ?? {};
        try {
          app.$emit("web_push", payload);
        } catch (error) {
          if (globalThis.window.$log) {
            globalThis.window.$log.error("FB onMessage error:", error);
          }
        }
      });

      const generateToken = async () => {
        const currentToken = await getToken(messaging, {
          vapidKey,
          serviceWorkerRegistration: registration
        });
        if (currentToken) {
          localStorage.setItem(
            "mobile_token",
            JSON.stringify({
              token: currentToken,
              system: "web",
              systemVersion: "N/A"
            })
          );
          return true;
        }
        return false;
      };

      const hasPushToken = await generateToken();
      if (!hasPushToken) {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          await generateToken();
        }
      }

      wb.addEventListener("message", event => {
        if (!event?.data?.isFirebaseMessaging) {
          const payload = event?.data;
          try {
            app.$emit("web_push", payload);
          } catch (error) {
            if (globalThis.window.$log) {
              globalThis.window.$log.error("Internal message error:", error);
            }
          }
        }
      });
    }
    return wb;
  } else {
    return null;
  }
}
